module.exports = {
  "country": "SE",
  "artist": "Charlotte Nilsson",
  "song": "Take me to Your Heaven",
  "year": "1999",
  "place": "1",
  "spotify": "5biCmbYZRtMf4QdBYi3gxE"
};